<template>
  <div class="obj-info" :id="'obj-info-' + object.Guid" style="visibility: visible" :class="{ active: true }">
    <table>
      <tr>
        <th><b>Техника:</b></th>
        <td><b>{{ object.Name }}</b></td>
      </tr>
      <tr>
        <th><b>Тип:</b></th>
        <td>{{ object.Type }}</td>
      </tr>
      <tr v-if="object.WorkDescription != ''">
        <th><b>Операция ТГ:</b></th>
        <td>{{ object.WorkDescription }}</td>
      </tr>
      <tr>
        <td><b>Занятость:</b></td>
        <td>{{ object.Status }}</td>
      </tr>
      <tr>
        <td><b>Номер рейса:</b></td>
        <td v-if="object.Flight === ''">Нет данных</td>
        <td v-else>{{ object.Flight === 'Нет данных' ? object.Flight : object.Flight + ' ' + object.FlightDate }}</td>
      </tr>
      <tr>
        <th><b>Номера борта:</b></th>
        <td v-if="object.Bort === ''">Нет данных</td>
        <td v-else>{{ object.Bort }}</td>
      </tr>
      <tr v-if="object.ArrivalAirport != 'Нет данных' && object.ArrivalAirport != ''">
        <td><b>АП отправления:</b></td>
        <td>{{ object.ArrivalAirport }}</td>
      </tr>
      <tr v-if="object.DepartureAirport != 'Нет данных' && object.DepartureAirport != ''">
        <td><b>АП прибытия:</b></td>
        <td>{{ object.DepartureAirport }}</td>
      </tr>
      <tr>
        <th><b>Водитель:</b></th>
        <td v-if="object.StaffName === ''">Нет данных</td>
        <td v-else>{{ object.StaffName }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'objectInfo',
  props: {
    object: {
      type: Object,
      // Для объектов или массивов значения по умолчанию
      // должны возвращаться из функции
      default: function () {
        return {}
      },
    },
  },
}
</script>

<style scoped>
.obj-info {
  display: flex;
  background: #fff;
  opacity: 1;
  top: 0;
  left: 0;
  color: #494963;
  width: auto;
  min-width: 200px;
  padding: 8px 6px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 1.6;
  width: 300px;
}

th {
  padding: 0px 2px;
  min-width: 100px;
  white-space: nowrap;
  vertical-align: top;
  line-height: 15px;
  text-align: left;
}

td {
  padding: 0px 2px;
  min-width: 100px;
  vertical-align: top;
  line-height: 15px;
  overflow-wrap: break-word;
}

tr {
  margin-top: 5px;
}
</style>
